"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const GenericButton_vue_1 = __importDefault(require("./GenericButton.vue"));
const FrkFlexContainer_vue_1 = __importDefault(require("./FrkFlexContainer.vue"));
const FrkHelpIcon_vue_1 = __importDefault(require("./FrkHelpIcon.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'FrkModal',
    props: {
        name: null,
        hideCloseButton: { type: Boolean, default: false },
        startingFromBottom: { type: Boolean, default: false }
    },
    emits: ['closed'],
    setup(__props, { emit }) {
        const props = __props;
        const $modal = (0, vue_2.getCurrentInstance)().proxy.$modal;
        const $slots = (0, vue_2.getCurrentInstance)().proxy.$slots;
        const isVisible = (0, vue_2.computed)(() => $modal.currentModal === props.name);
        const currentModal = (0, vue_2.computed)(() => $modal.currentModal);
        const roundedBorderClass = (0, vue_2.computed)(() => ($slots.foot ? '' : 'tw-rounded-b-xl'));
        (0, vue_2.watch)(currentModal, async (value, oldValue) => {
            if (value === props.name) {
                show();
            }
            else if (oldValue === props.name) {
                emit('closed');
            }
        });
        function show() {
            window.addEventListener('keyup', ev => {
                if (ev.key === 'Escape' && isVisible) {
                    $modal.hide();
                }
            });
        }
        return { __sfc: true, $modal, $slots, props, isVisible, currentModal, roundedBorderClass, emit, show, GenericButton: GenericButton_vue_1.default, FrkFlexContainer: FrkFlexContainer_vue_1.default, FrkHelpIcon: FrkHelpIcon_vue_1.default };
    }
});
